import styled from 'styled-components';
import { CardSaleSizes, ISizesPartialComponent, Media } from 'enums';
import { Link } from 'react-router-dom';

type Props = {
  salecardwidth?: ISizesPartialComponent;
};

type SaleCardImgProps = {
  isExpired?: boolean;
};

export const StickersDiv = styled.div`
  background: none;
  position: absolute;
  display: flex;
  z-index: 1;
  top: 14px;
  left: 14px;
  flex-direction: row;
  justify-content: center;
`;

export const SaleCard = styled(Link)<Props>`
  min-width: ${({ salecardwidth }) =>
    salecardwidth?.mobile?.width || CardSaleSizes.mobile.width};
  height: ${CardSaleSizes.mobile.height};
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  margin: 0;
  box-shadow: 0px 4px 15px 4px rgba(56, 55, 51, 0.03);
  cursor: pointer;
  text-decoration: none;

  @media ${Media.tablet} {
    min-width: ${({ salecardwidth }) =>
      salecardwidth?.tablet?.width || CardSaleSizes.tablet.width};
    height: ${CardSaleSizes.tablet.height};
  }

  @media ${Media.notebook} {
    min-width: ${({ salecardwidth }) =>
      salecardwidth?.notebook?.width || CardSaleSizes.notebook.width};
    height: ${CardSaleSizes.notebook.height};
  }

  @media ${Media.desktop} {
    min-width: ${({ salecardwidth }) =>
      salecardwidth?.desktop?.width || CardSaleSizes.desktop.width};
    height: ${CardSaleSizes.desktop.height};
  }
`;

export const SaleCardImg = styled.img<SaleCardImgProps>`
  width: 100%;
  height: 205px;
  object-fit: cover;
  filter: ${({ isExpired }) => (isExpired ? 'grayscale(100%)' : null)};

  @media ${Media.notebook} {
    height: 198px;
  }
`;

export const FavoriteContainer = styled.div`
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 1;
`;

export const RatingContainer = styled.div`
  position: absolute;
  z-index: 1;
  display: flex;
  justify-content: flex-start;
  width: auto;
  flex-wrap: wrap;
  bottom: 100px;
  right: 14px;
`;
